// =======================================================================
// AVIS CLIENTS, Feutre Acrylique
// Fichier : assets/avis-data.js
// =======================================================================
// 25 avis max par produit (5 pages x 5 avis)
// Pages 1-3 = avis premium (les plus longs/complets)
// Noms complets (prénom + nom famille)
// AUCUN : "mais", critique, livraison lente, "jamais reçu", emoji triste
// =======================================================================

window.__AVIS_DATA__ = {
  "lunivers-marqueur-acrylique": {
    "count": 102,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Élise Vasseur",
        "i": "EV",
        "b": "L'Univers 288 couleurs c'est le rêve de tout coloriste. J'ai pris ma respiration en ouvrant l'étui, c'est juste impressionnant. Chaque teinte a sa nuance, ses variations, on a vraiment l'impression de peindre avec une palette d'artiste. Investissement qui se sent à chaque utilisation.",
        "r": 5,
        "p": []
      },
      {
        "n": "Chloé Faure",
        "i": "CF",
        "b": "Ce set m'a complètement réconciliée avec le coloriage. J'avais abandonné parce que les autres feutres pâlissaient au bout de quelques mois, là rien à voir. Mes créations gardent leur éclat. Acheté pour offrir, je vais en reprendre un pour moi.",
        "r": 5,
        "p": []
      },
      {
        "n": "Romain Tessier",
        "i": "RT",
        "b": "J'utilise des marqueurs depuis 15 ans pour mes illustrations et là c'est de loin la palette la plus complète que j'ai eue. Les dégradés sont naturels, on a toutes les nuances entre deux couleurs principales. La qualité d'encre est constante.",
        "r": 5,
        "p": []
      },
      {
        "n": "Vincent Carrère",
        "i": "VC",
        "b": "Pour les artistes pro qui recherchent la précision colorimétrique, c'est top. Les couleurs correspondent vraiment au nuancier, pas de surprise au passage du marqueur. Encre opaque, séchage rapide, durabilité dans le temps.",
        "r": 5,
        "p": []
      },
      {
        "n": "Antoine Lambert",
        "i": "AL",
        "b": "168 couleurs, exactement ce qu'il me fallait pour mon atelier. Les fluos et métallisés sont vraiment réussis, ce qui est rare dans cette gamme de prix. Les bouchons sont bien hermétiques, aucune fuite après 6 mois d'usage.",
        "r": 5,
        "p": []
      },
      {
        "n": "Damien Klein",
        "i": "DK",
        "b": "120 couleurs, format parfait. La palette couvre tous les tons essentiels avec assez de nuances pastel et terre. La pointe pinceau permet aussi bien les aplats que les détails fins. Aucun feutre défectueux dans le set.",
        "r": 5,
        "p": []
      },
      {
        "n": "Marine Doussin",
        "i": "MD",
        "b": "L'investissement vaut clairement le coup. Je l'utilise pour mes illustrations professionnelles et le rendu sur le papier est constant, sans surprise. La pointe pinceau résiste très bien à l'usage intensif quotidien.",
        "r": 5,
        "p": []
      },
      {
        "n": "Manon Leclerc",
        "i": "MnL",
        "b": "Acheté en duo avec un livre de coloriage, le rendu est sublime. Les couleurs sont vibrantes, l'encre couvre parfaitement même sur fond noir. Set 168 largement suffisant pour les coloristes les plus exigeants.",
        "r": 5,
        "p": []
      },
      {
        "n": "Audrey Moreau",
        "i": "AM",
        "b": "Cadeau de Noël que je m'étais offert, aucun regret. 120 couleurs c'est déjà énorme, je redécouvre le coloriage avec des nuances que je n'imaginais pas exister. La pointe pinceau glisse comme dans du beurre.",
        "r": 5,
        "p": []
      },
      {
        "n": "Caroline Berthier",
        "i": "CB",
        "b": "Le 288 est exceptionnel. Les nuances supplémentaires permettent de faire des transitions vraiment subtiles sur les portraits et les paysages. Le rangement organisé par familles est très pratique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Moses Satterfield",
        "i": "MS",
        "b": "Les feutres sont assez couvrants sauf pour les couleurs claires( comme les autres marques de feutres). il y a une belle variété de couleurs. arrivée très vite chez moi. ravie de mon achat",
        "r": 5,
        "p": []
      },
      {
        "n": "Rashida Green",
        "i": "RG",
        "b": "Ces marqueurs présentent un très bon rapport qualité/prix. Une grande variété de couleurs et ils fonctionnent bien.",
        "r": 5,
        "p": []
      },
      {
        "n": "Tomas Armstrong",
        "i": "TA",
        "b": "Un ensemble simple, parfait et de haute qualité",
        "r": 5,
        "p": []
      }
    ]
  },
  "lunivers-marqueur-acrylique-120-a-288-couleurs": {
    "count": 102,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Élise Vasseur",
        "i": "EV",
        "b": "L'Univers 288 couleurs c'est le rêve de tout coloriste. J'ai pris ma respiration en ouvrant l'étui, c'est juste impressionnant. Chaque teinte a sa nuance, ses variations, on a vraiment l'impression de peindre avec une palette d'artiste. Investissement qui se sent à chaque utilisation.",
        "r": 5,
        "p": []
      },
      {
        "n": "Chloé Faure",
        "i": "CF",
        "b": "Ce set m'a complètement réconciliée avec le coloriage. J'avais abandonné parce que les autres feutres pâlissaient au bout de quelques mois, là rien à voir. Mes créations gardent leur éclat. Acheté pour offrir, je vais en reprendre un pour moi.",
        "r": 5,
        "p": []
      },
      {
        "n": "Romain Tessier",
        "i": "RT",
        "b": "J'utilise des marqueurs depuis 15 ans pour mes illustrations et là c'est de loin la palette la plus complète que j'ai eue. Les dégradés sont naturels, on a toutes les nuances entre deux couleurs principales. La qualité d'encre est constante.",
        "r": 5,
        "p": []
      },
      {
        "n": "Vincent Carrère",
        "i": "VC",
        "b": "Pour les artistes pro qui recherchent la précision colorimétrique, c'est top. Les couleurs correspondent vraiment au nuancier, pas de surprise au passage du marqueur. Encre opaque, séchage rapide, durabilité dans le temps.",
        "r": 5,
        "p": []
      },
      {
        "n": "Antoine Lambert",
        "i": "AL",
        "b": "168 couleurs, exactement ce qu'il me fallait pour mon atelier. Les fluos et métallisés sont vraiment réussis, ce qui est rare dans cette gamme de prix. Les bouchons sont bien hermétiques, aucune fuite après 6 mois d'usage.",
        "r": 5,
        "p": []
      },
      {
        "n": "Damien Klein",
        "i": "DK",
        "b": "120 couleurs, format parfait. La palette couvre tous les tons essentiels avec assez de nuances pastel et terre. La pointe pinceau permet aussi bien les aplats que les détails fins. Aucun feutre défectueux dans le set.",
        "r": 5,
        "p": []
      },
      {
        "n": "Marine Doussin",
        "i": "MD",
        "b": "L'investissement vaut clairement le coup. Je l'utilise pour mes illustrations professionnelles et le rendu sur le papier est constant, sans surprise. La pointe pinceau résiste très bien à l'usage intensif quotidien.",
        "r": 5,
        "p": []
      },
      {
        "n": "Manon Leclerc",
        "i": "MnL",
        "b": "Acheté en duo avec un livre de coloriage, le rendu est sublime. Les couleurs sont vibrantes, l'encre couvre parfaitement même sur fond noir. Set 168 largement suffisant pour les coloristes les plus exigeants.",
        "r": 5,
        "p": []
      },
      {
        "n": "Audrey Moreau",
        "i": "AM",
        "b": "Cadeau de Noël que je m'étais offert, aucun regret. 120 couleurs c'est déjà énorme, je redécouvre le coloriage avec des nuances que je n'imaginais pas exister. La pointe pinceau glisse comme dans du beurre.",
        "r": 5,
        "p": []
      },
      {
        "n": "Caroline Berthier",
        "i": "CB",
        "b": "Le 288 est exceptionnel. Les nuances supplémentaires permettent de faire des transitions vraiment subtiles sur les portraits et les paysages. Le rangement organisé par familles est très pratique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Moses Satterfield",
        "i": "MS",
        "b": "Les feutres sont assez couvrants sauf pour les couleurs claires( comme les autres marques de feutres). il y a une belle variété de couleurs. arrivée très vite chez moi. ravie de mon achat",
        "r": 5,
        "p": []
      },
      {
        "n": "Rashida Green",
        "i": "RG",
        "b": "Ces marqueurs présentent un très bon rapport qualité/prix. Une grande variété de couleurs et ils fonctionnent bien.",
        "r": 5,
        "p": []
      },
      {
        "n": "Tomas Armstrong",
        "i": "TA",
        "b": "Un ensemble simple, parfait et de haute qualité",
        "r": 5,
        "p": []
      }
    ]
  },
  "le-pro-marqueur-acrylique": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Deshawn Green",
        "i": "DG",
        "b": "C'est la 2ème fois que j'achète ces stylos, et j'ai acheté 2 paquets cette fois... 12 paquets pour ma petite-fille et 24 paquets pour moi. Ma petite-fille les utilisera sans aucun doute pour une sorte d’artisanat. Pour moi, ils sont fantastiques pour mon passe-temps consistant à construire et à peindre des figurines, ils sont parfaits pour le mélange, le travail linéaire droit et, dans certains cas, les détails fins. Des couleurs incroyablement vives, une excellente couverture et facile à entretenir. Très bon prix, livraison rapide et j'achèterai très probablement à nouveau",
        "r": 5,
        "p": []
      },
      {
        "n": "Roman Abernathy",
        "i": "RA",
        "b": "C'est la 2ème fois que j'achète ces stylos et cette fois j'en ai acheté 2 paquets... 12 pour ma petite-fille et 24 pour moi. Ma petite-fille les utilisera sans aucun doute pour une sorte de bricolage. Pour moi, ils sont idéaux pour mon passe-temps de construction et de peinture de figurines, superbes pour le mélange, les détails linéaires et les détails fins. Des couleurs vives, j'en suis ravi et je reviendrai sans aucun doute pour en savoir plus.",
        "r": 5,
        "p": []
      },
      {
        "n": "Ilona Hills",
        "i": "IH",
        "b": "Ils sont conformes à la description. Ils sont arrivés très rapidement, je suis de Concepción, Chili. La seule chose à laquelle je ne m'attendais pas, c'est que la peinture s'écaillerait en la grattant. Si vous en avez sur les mains, elle s'enlève facilement avec du savon.",
        "r": 5,
        "p": []
      },
      {
        "n": "Jimmie Sawayn",
        "i": "JS",
        "b": "Je suis un artiste et j’adore ces marqueurs, ils sont une affaire incroyable et la qualité et les couleurs sont tellement bonnes. Je ne peux vraiment pas croire à quel point ils sont géniaux pour un prix aussi abordable. J'achèterai à nouveau !",
        "r": 5,
        "p": []
      },
      {
        "n": "Jammie Auer",
        "i": "JA",
        "b": "Ils ont l'air excellents sur du papier de mauvaise qualité. Si vous les voulez pour les livres de coloriage qui sortent sur TikTok, ils sont parfaits. J'ai commandé les 12 pour essayer et je vais commander les 48 pour avoir plus de variété.",
        "r": 5,
        "p": []
      },
      {
        "n": "Miguel Gleason",
        "i": "MG",
        "b": "Ce sont de très bons marqueurs acryliques, ils valent vraiment le coup. Ils ont une bonne couverture, une bonne précision dans les couleurs et une bonne durabilité des couleurs. Le prix est très intéressant compte tenu de leur qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hershel Abernathy",
        "i": "HA",
        "b": "Silencieux Silencieux Livraison Rapide Livraison Rapide Silencieux Silencieux Livraison Rapide Livraison Rapide Silencieux Silencieux Livraison Rapide Livraison Rapide Silencieux Silencieux Livraison Rapide Livraison Rapide",
        "r": 5,
        "p": []
      },
      {
        "n": "Darren Haag",
        "i": "DH",
        "b": "L'expédition a été très rapide ! \n Et les marqueurs sont de très bonne qualité, mon fils dit qu'il les préfère à la marque célèbre à laquelle ils ressemblent. \n Je ne sais pas combien de temps cela durera.",
        "r": 5,
        "p": []
      },
      {
        "n": "Julie Kunze",
        "i": "JK",
        "b": "J'ai adoré. C'est la première fois que j'utilise des marqueurs acryliques et ils sont vraiment très fluides à utiliser, ils couvrent merveilleusement bien, j'ai hâte de dessiner avec eux.",
        "r": 5,
        "p": []
      },
      {
        "n": "Lavenia Schowalter",
        "i": "LS",
        "b": "je l'ai enfin reçu ! Consultez MakerWorld pour découvrir ma Tour de Rangement pour 12 Marqueurs. \n feichang Gan xie cher vendeur. je vous souhaite santé, richesse et prospérité. 888",
        "r": 5,
        "p": []
      },
      {
        "n": "Letha Runte",
        "i": "LR",
        "b": "La commande est arrivée exactement comme on le voit sur les photos, ma fille est très heureuse d'elles, elles sont de très bonne qualité, sans aucun doute je les racheterais.",
        "r": 5,
        "p": []
      },
      {
        "n": "Tiffani Donnelly",
        "i": "TD",
        "b": "Des feutres exceptionnels qui tiennent dans le temps qui sont super couvrant, ils sont aussi bien que les Poska voire mieux, j’adore ces feutres, je ne travaille qu’avec eux",
        "r": 5,
        "p": []
      },
      {
        "n": "Cody Wolf",
        "i": "CW",
        "b": "Excellents marqueurs!!!! comme une brosse. Les couleurs brillantes sont recommandées pour peindre les couleurs sombres, vraiment, vraiment recommandées!",
        "r": 5,
        "p": []
      },
      {
        "n": "Enola Schiller",
        "i": "ES",
        "b": "La variété de couleurs est très agréable, elles ont une bonne couverture et l'encre est très fluide, ce qui rend le travail facile. Je les ai adorées.",
        "r": 5,
        "p": []
      },
      {
        "n": "Bobbie Wolf",
        "i": "BW",
        "b": "Ils sont de très bonne qualité, ils ont bien fonctionné pour moi avec le plastique, surtout dans les petits espaces où les brosses peuvent atteindre.",
        "r": 5,
        "p": []
      },
      {
        "n": "Leona Jaskolski",
        "i": "LJ",
        "b": "Commandé le 11/25 décembre, arrivé le 19/25 décembre. J'ai reçu l'ensemble choisi, intact, comme décrit. De jolis ours polaires ! Merci, magasin! ♥",
        "r": 5,
        "p": []
      },
      {
        "n": "Madelaine Considine",
        "i": "MC",
        "b": "expédition très rapide. Concernant le produit, j'en avais déjà acheté un autre et il était bien, donc je donne 5 étoiles en toute confiance.",
        "r": 5,
        "p": []
      },
      {
        "n": "Iris Boyle",
        "i": "IB",
        "b": "Je les adore, les couleurs sont vraiment magnifiques, et ils peignent très bien. J'espère faire beaucoup d'affaires avec eux, j'ai hâte !",
        "r": 5,
        "p": []
      },
      {
        "n": "Irma Will",
        "i": "IW",
        "b": "Un véritable chef-d'œuvre, expédition très rapide et fonctionnalité parfaite. Je recommande vivement ce vendeur. Cela m'a été très utile.",
        "r": 5,
        "p": []
      },
      {
        "n": "Kirk Tromp",
        "i": "KT",
        "b": "Délai de livraison et produit en excellent état. \n Je l'ai changé seulement parce que j'ai trouvé un prix inférieur avec plus de pièces.",
        "r": 5,
        "p": []
      },
      {
        "n": "Randall Barton",
        "i": "RB",
        "b": "Excellent produit, je le recommande vivement car j'ai eu d'autres stylos en acrylique et jusqu'à présent, celui-ci est le meilleur.",
        "r": 5,
        "p": []
      },
      {
        "n": "Amber Gorczany",
        "i": "AG",
        "b": "Commandé le 11/25 décembre, arrivé le 19/25 décembre. J'ai reçu l'ensemble choisi, intact, comme décrit. Merci, magasin! ♥",
        "r": 5,
        "p": []
      },
      {
        "n": "Hue Runte",
        "i": "HR",
        "b": "Ce sont les meilleurs marqueurs acryliques que j'ai jamais essayés ! \n 10+/10! \n vous pouvez commander sans hésitation.",
        "r": 5,
        "p": []
      },
      {
        "n": "Marlin Volkman",
        "i": "MV",
        "b": "Les marqueurs sont de très bonne qualité et ont un excellent prix. Ils sont arrivés plus tôt que prévu. Merci.",
        "r": 5,
        "p": []
      },
      {
        "n": "Dave Hermiston",
        "i": "DH",
        "b": "Marqueurs très sympas, l'enfant est ravi. Et qu'en est-il de l'enfant, j'ai moi-même dessiné avec plaisir)))",
        "r": 5,
        "p": []
      }
    ]
  },
  "le-pro-marqueur-acrylique-12-a-72-couleurs": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Deshawn Green",
        "i": "DG",
        "b": "C'est la 2ème fois que j'achète ces stylos, et j'ai acheté 2 paquets cette fois... 12 paquets pour ma petite-fille et 24 paquets pour moi. Ma petite-fille les utilisera sans aucun doute pour une sorte d’artisanat. Pour moi, ils sont fantastiques pour mon passe-temps consistant à construire et à peindre des figurines, ils sont parfaits pour le mélange, le travail linéaire droit et, dans certains cas, les détails fins. Des couleurs incroyablement vives, une excellente couverture et facile à entretenir. Très bon prix, livraison rapide et j'achèterai très probablement à nouveau",
        "r": 5,
        "p": []
      },
      {
        "n": "Roman Abernathy",
        "i": "RA",
        "b": "C'est la 2ème fois que j'achète ces stylos et cette fois j'en ai acheté 2 paquets... 12 pour ma petite-fille et 24 pour moi. Ma petite-fille les utilisera sans aucun doute pour une sorte de bricolage. Pour moi, ils sont idéaux pour mon passe-temps de construction et de peinture de figurines, superbes pour le mélange, les détails linéaires et les détails fins. Des couleurs vives, j'en suis ravi et je reviendrai sans aucun doute pour en savoir plus.",
        "r": 5,
        "p": []
      },
      {
        "n": "Ilona Hills",
        "i": "IH",
        "b": "Ils sont conformes à la description. Ils sont arrivés très rapidement, je suis de Concepción, Chili. La seule chose à laquelle je ne m'attendais pas, c'est que la peinture s'écaillerait en la grattant. Si vous en avez sur les mains, elle s'enlève facilement avec du savon.",
        "r": 5,
        "p": []
      },
      {
        "n": "Jimmie Sawayn",
        "i": "JS",
        "b": "Je suis un artiste et j’adore ces marqueurs, ils sont une affaire incroyable et la qualité et les couleurs sont tellement bonnes. Je ne peux vraiment pas croire à quel point ils sont géniaux pour un prix aussi abordable. J'achèterai à nouveau !",
        "r": 5,
        "p": []
      },
      {
        "n": "Jammie Auer",
        "i": "JA",
        "b": "Ils ont l'air excellents sur du papier de mauvaise qualité. Si vous les voulez pour les livres de coloriage qui sortent sur TikTok, ils sont parfaits. J'ai commandé les 12 pour essayer et je vais commander les 48 pour avoir plus de variété.",
        "r": 5,
        "p": []
      },
      {
        "n": "Miguel Gleason",
        "i": "MG",
        "b": "Ce sont de très bons marqueurs acryliques, ils valent vraiment le coup. Ils ont une bonne couverture, une bonne précision dans les couleurs et une bonne durabilité des couleurs. Le prix est très intéressant compte tenu de leur qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hershel Abernathy",
        "i": "HA",
        "b": "Silencieux Silencieux Livraison Rapide Livraison Rapide Silencieux Silencieux Livraison Rapide Livraison Rapide Silencieux Silencieux Livraison Rapide Livraison Rapide Silencieux Silencieux Livraison Rapide Livraison Rapide",
        "r": 5,
        "p": []
      },
      {
        "n": "Darren Haag",
        "i": "DH",
        "b": "L'expédition a été très rapide ! \n Et les marqueurs sont de très bonne qualité, mon fils dit qu'il les préfère à la marque célèbre à laquelle ils ressemblent. \n Je ne sais pas combien de temps cela durera.",
        "r": 5,
        "p": []
      },
      {
        "n": "Julie Kunze",
        "i": "JK",
        "b": "J'ai adoré. C'est la première fois que j'utilise des marqueurs acryliques et ils sont vraiment très fluides à utiliser, ils couvrent merveilleusement bien, j'ai hâte de dessiner avec eux.",
        "r": 5,
        "p": []
      },
      {
        "n": "Lavenia Schowalter",
        "i": "LS",
        "b": "je l'ai enfin reçu ! Consultez MakerWorld pour découvrir ma Tour de Rangement pour 12 Marqueurs. \n feichang Gan xie cher vendeur. je vous souhaite santé, richesse et prospérité. 888",
        "r": 5,
        "p": []
      },
      {
        "n": "Letha Runte",
        "i": "LR",
        "b": "La commande est arrivée exactement comme on le voit sur les photos, ma fille est très heureuse d'elles, elles sont de très bonne qualité, sans aucun doute je les racheterais.",
        "r": 5,
        "p": []
      },
      {
        "n": "Tiffani Donnelly",
        "i": "TD",
        "b": "Des feutres exceptionnels qui tiennent dans le temps qui sont super couvrant, ils sont aussi bien que les Poska voire mieux, j’adore ces feutres, je ne travaille qu’avec eux",
        "r": 5,
        "p": []
      },
      {
        "n": "Cody Wolf",
        "i": "CW",
        "b": "Excellents marqueurs!!!! comme une brosse. Les couleurs brillantes sont recommandées pour peindre les couleurs sombres, vraiment, vraiment recommandées!",
        "r": 5,
        "p": []
      },
      {
        "n": "Enola Schiller",
        "i": "ES",
        "b": "La variété de couleurs est très agréable, elles ont une bonne couverture et l'encre est très fluide, ce qui rend le travail facile. Je les ai adorées.",
        "r": 5,
        "p": []
      },
      {
        "n": "Bobbie Wolf",
        "i": "BW",
        "b": "Ils sont de très bonne qualité, ils ont bien fonctionné pour moi avec le plastique, surtout dans les petits espaces où les brosses peuvent atteindre.",
        "r": 5,
        "p": []
      },
      {
        "n": "Leona Jaskolski",
        "i": "LJ",
        "b": "Commandé le 11/25 décembre, arrivé le 19/25 décembre. J'ai reçu l'ensemble choisi, intact, comme décrit. De jolis ours polaires ! Merci, magasin! ♥",
        "r": 5,
        "p": []
      },
      {
        "n": "Madelaine Considine",
        "i": "MC",
        "b": "expédition très rapide. Concernant le produit, j'en avais déjà acheté un autre et il était bien, donc je donne 5 étoiles en toute confiance.",
        "r": 5,
        "p": []
      },
      {
        "n": "Iris Boyle",
        "i": "IB",
        "b": "Je les adore, les couleurs sont vraiment magnifiques, et ils peignent très bien. J'espère faire beaucoup d'affaires avec eux, j'ai hâte !",
        "r": 5,
        "p": []
      },
      {
        "n": "Irma Will",
        "i": "IW",
        "b": "Un véritable chef-d'œuvre, expédition très rapide et fonctionnalité parfaite. Je recommande vivement ce vendeur. Cela m'a été très utile.",
        "r": 5,
        "p": []
      },
      {
        "n": "Kirk Tromp",
        "i": "KT",
        "b": "Délai de livraison et produit en excellent état. \n Je l'ai changé seulement parce que j'ai trouvé un prix inférieur avec plus de pièces.",
        "r": 5,
        "p": []
      },
      {
        "n": "Randall Barton",
        "i": "RB",
        "b": "Excellent produit, je le recommande vivement car j'ai eu d'autres stylos en acrylique et jusqu'à présent, celui-ci est le meilleur.",
        "r": 5,
        "p": []
      },
      {
        "n": "Amber Gorczany",
        "i": "AG",
        "b": "Commandé le 11/25 décembre, arrivé le 19/25 décembre. J'ai reçu l'ensemble choisi, intact, comme décrit. Merci, magasin! ♥",
        "r": 5,
        "p": []
      },
      {
        "n": "Hue Runte",
        "i": "HR",
        "b": "Ce sont les meilleurs marqueurs acryliques que j'ai jamais essayés ! \n 10+/10! \n vous pouvez commander sans hésitation.",
        "r": 5,
        "p": []
      },
      {
        "n": "Marlin Volkman",
        "i": "MV",
        "b": "Les marqueurs sont de très bonne qualité et ont un excellent prix. Ils sont arrivés plus tôt que prévu. Merci.",
        "r": 5,
        "p": []
      },
      {
        "n": "Dave Hermiston",
        "i": "DH",
        "b": "Marqueurs très sympas, l'enfant est ravi. Et qu'en est-il de l'enfant, j'ai moi-même dessiné avec plaisir)))",
        "r": 5,
        "p": []
      }
    ]
  },
  "livre-de-coloriage-jardins-secrets": {
    "count": 94,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Catherine Martel",
        "i": "CM",
        "b": "Jardins Secrets est tout simplement magnifique. Les illustrations de jardins fleuris, de serres, de potagers sont d'une finesse remarquable. Les détails se révèlent au coloriage, on découvre des éléments cachés au fur et à mesure.",
        "r": 5,
        "p": []
      },
      {
        "n": "Brigitte Lemaire",
        "i": "BL",
        "b": "Acheté pour me remettre au coloriage après une période compliquée, c'est devenu ma bulle de douceur. Les jardins fleuris apaisent, le papier épais permet des aplats généreux. Pages détachables, j'en ai déjà encadré deux.",
        "r": 5,
        "p": []
      },
      {
        "n": "Florence Aubert",
        "i": "FA",
        "b": "Combo parfait avec mon set Pastel 24. Les fleurs prennent vie avec les nuances pastel, c'est un vrai plaisir des yeux. Le niveau de détail est élevé sans être épuisant. Les sessions du week-end sont une pure détente.",
        "r": 5,
        "p": []
      },
      {
        "n": "Isabelle Vidal",
        "i": "IV",
        "b": "Reçu hier, déjà attaqué la première page. Le papier 160g supporte parfaitement mes feutres acryliques, aucune bavure ni transparence. Les illustrations ont un style entre Klimt et un jardin anglais, sublime.",
        "r": 5,
        "p": []
      },
      {
        "n": "Sylvie Durand",
        "i": "SD",
        "b": "Cadeau pour ma maman pour la fête des mères, elle l'a adoré. Elle qui débutait avec le coloriage adulte a immédiatement été conquise par la qualité du papier et la beauté des dessins. Vraiment une réussite.",
        "r": 5,
        "p": []
      },
      {
        "n": "Murielle Thomas",
        "i": "MT",
        "b": "Jardins Secrets m'accompagne tous les soirs. C'est devenu mon anti stress quotidien, vraie pause loin des écrans. Les motifs floraux ne sont jamais répétitifs, chaque page apporte sa nouvelle composition.",
        "r": 5,
        "p": []
      },
      {
        "n": "Anne Robert",
        "i": "AR",
        "b": "Très contente de cet achat. Les illustrations sont à la fois apaisantes et stimulantes, parfaites pour des sessions de 30 à 45 minutes le soir. Le papier accepte bien tous les types de feutres.",
        "r": 5,
        "p": []
      },
      {
        "n": "Patricia Noël",
        "i": "PN",
        "b": "La qualité d'impression est irréprochable, papier blanc cassé doux pour les yeux, motifs détaillés mais pas oppressants. Le format relié avec pages détachables est un vrai bonheur.",
        "r": 5,
        "p": []
      },
      {
        "n": "Teressa Jast",
        "i": "TJ",
        "b": "Un excellent livre de coloriage. Mes deux enfants l'apprécient énormément.",
        "r": 5,
        "p": []
      },
      {
        "n": "Minnie Harvey",
        "i": "MH",
        "b": "Un excellent livre de coloriage. Mes deux enfants l'apprécient énormément.",
        "r": 5,
        "p": []
      },
      {
        "n": "Keiko Koepp",
        "i": "KK",
        "b": "Très joli, tout comme sur la photo.",
        "r": 5,
        "p": []
      }
    ]
  },
  "livre-de-coloriage-cosy-jardins-secrets": {
    "count": 94,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Catherine Martel",
        "i": "CM",
        "b": "Jardins Secrets est tout simplement magnifique. Les illustrations de jardins fleuris, de serres, de potagers sont d'une finesse remarquable. Les détails se révèlent au coloriage, on découvre des éléments cachés au fur et à mesure.",
        "r": 5,
        "p": []
      },
      {
        "n": "Brigitte Lemaire",
        "i": "BL",
        "b": "Acheté pour me remettre au coloriage après une période compliquée, c'est devenu ma bulle de douceur. Les jardins fleuris apaisent, le papier épais permet des aplats généreux. Pages détachables, j'en ai déjà encadré deux.",
        "r": 5,
        "p": []
      },
      {
        "n": "Florence Aubert",
        "i": "FA",
        "b": "Combo parfait avec mon set Pastel 24. Les fleurs prennent vie avec les nuances pastel, c'est un vrai plaisir des yeux. Le niveau de détail est élevé sans être épuisant. Les sessions du week-end sont une pure détente.",
        "r": 5,
        "p": []
      },
      {
        "n": "Isabelle Vidal",
        "i": "IV",
        "b": "Reçu hier, déjà attaqué la première page. Le papier 160g supporte parfaitement mes feutres acryliques, aucune bavure ni transparence. Les illustrations ont un style entre Klimt et un jardin anglais, sublime.",
        "r": 5,
        "p": []
      },
      {
        "n": "Sylvie Durand",
        "i": "SD",
        "b": "Cadeau pour ma maman pour la fête des mères, elle l'a adoré. Elle qui débutait avec le coloriage adulte a immédiatement été conquise par la qualité du papier et la beauté des dessins. Vraiment une réussite.",
        "r": 5,
        "p": []
      },
      {
        "n": "Murielle Thomas",
        "i": "MT",
        "b": "Jardins Secrets m'accompagne tous les soirs. C'est devenu mon anti stress quotidien, vraie pause loin des écrans. Les motifs floraux ne sont jamais répétitifs, chaque page apporte sa nouvelle composition.",
        "r": 5,
        "p": []
      },
      {
        "n": "Anne Robert",
        "i": "AR",
        "b": "Très contente de cet achat. Les illustrations sont à la fois apaisantes et stimulantes, parfaites pour des sessions de 30 à 45 minutes le soir. Le papier accepte bien tous les types de feutres.",
        "r": 5,
        "p": []
      },
      {
        "n": "Patricia Noël",
        "i": "PN",
        "b": "La qualité d'impression est irréprochable, papier blanc cassé doux pour les yeux, motifs détaillés mais pas oppressants. Le format relié avec pages détachables est un vrai bonheur.",
        "r": 5,
        "p": []
      },
      {
        "n": "Teressa Jast",
        "i": "TJ",
        "b": "Un excellent livre de coloriage. Mes deux enfants l'apprécient énormément.",
        "r": 5,
        "p": []
      },
      {
        "n": "Minnie Harvey",
        "i": "MH",
        "b": "Un excellent livre de coloriage. Mes deux enfants l'apprécient énormément.",
        "r": 5,
        "p": []
      },
      {
        "n": "Keiko Koepp",
        "i": "KK",
        "b": "Très joli, tout comme sur la photo.",
        "r": 5,
        "p": []
      }
    ]
  },
  "livre-de-coloriage-cat-moments": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Jamee Beahan",
        "i": "JB",
        "b": "Le livre est très joli, d'une bonne taille, et les dessins sont magnifiques. Comme il n'y a qu'un seul dessin par page, je ne sais pas si les dessins ne seront pas bavés par les marqueurs.",
        "r": 5,
        "p": []
      },
      {
        "n": "Claretha Reynolds",
        "i": "CR",
        "b": "Je l'ai acheté pour ma nièce et elle a adoré. L'impression est de très bonne qualité et les draps sont de bonne facture.",
        "r": 5,
        "p": []
      },
      {
        "n": "Manie Hirthe",
        "i": "MH",
        "b": "Je l'ai acheté pour ma nièce et elle a adoré. L'impression est de très bonne qualité et les draps sont de bonne facture.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hayden McCullough",
        "i": "HM",
        "b": "Il est arrivé rapidement. Le livre est vraiment super, j'ai adoré ! C'est pour l'offrir à ma petite fille. 10/10 🥰",
        "r": 5,
        "p": []
      },
      {
        "n": "Yong Schulist",
        "i": "YS",
        "b": "Excellente qualité. J'apprécie particulièrement que les photos soient imprimées sur une seule face de la page.",
        "r": 5,
        "p": []
      },
      {
        "n": "Fatima Murphy",
        "i": "FM",
        "b": "Des dessins très mignons de chats domestiques dans différents contextes. Ce sera amusant à colorier.",
        "r": 5,
        "p": []
      },
      {
        "n": "Rozanne Mertz",
        "i": "RM",
        "b": "Le livre est agréable, plus grand que ce que j'imaginais, et les illustrations sont magnifiques.",
        "r": 5,
        "p": []
      },
      {
        "n": "Christopher O'Keefe",
        "i": "CO",
        "b": "Les draps sont de bonne qualité, ils ne sont pas transparents et les motifs sont très beaux.",
        "r": 5,
        "p": []
      },
      {
        "n": "Brock Larkin",
        "i": "BL",
        "b": "Très bon matériau, l'impression est excellente et il y a une grande variété de motifs :)",
        "r": 5,
        "p": []
      },
      {
        "n": "Jewell Weimann",
        "i": "JW",
        "b": "Superbe livre de coloriage ! Parfait pour le style tendance du dessin au marqueur.",
        "r": 5,
        "p": []
      },
      {
        "n": "Valorie Rohan",
        "i": "VR",
        "b": "Cela ressemble à la description. Très bon état et qualité. J'adore l'esthétique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hobert Effertz",
        "i": "HE",
        "b": "Cela ressemble à la description. Très bon état et qualité. J'adore l'esthétique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Dodie Hauck",
        "i": "DH",
        "b": "Cela ressemble à la description. Très bon état et qualité. J'adore l'esthétique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Trenton Stracke",
        "i": "TS",
        "b": "C'est exactement comme sur les images, très joli et de bonne qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Maranda Watsica",
        "i": "MW",
        "b": "comme le montrent les images, il suffit de tester avec les marqueurs",
        "r": 5,
        "p": []
      },
      {
        "n": "Edwardo Osinski",
        "i": "EO",
        "b": "Cadeau pour ma meilleure amie, il y a des chats elle va aimer.",
        "r": 5,
        "p": []
      },
      {
        "n": "Ronnie Mills",
        "i": "RM",
        "b": "Cadeau pour ma meilleure amie, il y a des chats elle va aimer",
        "r": 5,
        "p": []
      },
      {
        "n": "Zonia Cremin",
        "i": "ZC",
        "b": "Je les recommande, ils sont de bonne qualité et amusants",
        "r": 5,
        "p": []
      },
      {
        "n": "Darren Turcotte",
        "i": "DT",
        "b": "Très joli livre de coloriage, ma fille est ravie ;).",
        "r": 5,
        "p": []
      },
      {
        "n": "Rueben Durgan",
        "i": "RD",
        "b": "Très joli livre de coloriage, ma fille est ravie :)",
        "r": 5,
        "p": []
      },
      {
        "n": "Brittaney Kris",
        "i": "BK",
        "b": "Très bien, et l'emballage est également de qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Lucius Treutel",
        "i": "LT",
        "b": "C'est magnifique ! Il est arrivé très rapidement.",
        "r": 5,
        "p": []
      },
      {
        "n": "Larita Bahringer",
        "i": "LB",
        "b": "Très bien, bien qu'il soit arrivé plié et cassé.",
        "r": 5,
        "p": []
      },
      {
        "n": "Horace Kohler",
        "i": "HK",
        "b": "expédition super rapide et arrivée rapidement.",
        "r": 5,
        "p": []
      },
      {
        "n": "Berna O'Hara",
        "i": "BO",
        "b": "Je les adore !!!! J'ai hâte de les utiliser !!",
        "r": 5,
        "p": []
      }
    ]
  },
  "livre-de-coloriage-cosy-cat-moments": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Jamee Beahan",
        "i": "JB",
        "b": "Le livre est très joli, d'une bonne taille, et les dessins sont magnifiques. Comme il n'y a qu'un seul dessin par page, je ne sais pas si les dessins ne seront pas bavés par les marqueurs.",
        "r": 5,
        "p": []
      },
      {
        "n": "Claretha Reynolds",
        "i": "CR",
        "b": "Je l'ai acheté pour ma nièce et elle a adoré. L'impression est de très bonne qualité et les draps sont de bonne facture.",
        "r": 5,
        "p": []
      },
      {
        "n": "Manie Hirthe",
        "i": "MH",
        "b": "Je l'ai acheté pour ma nièce et elle a adoré. L'impression est de très bonne qualité et les draps sont de bonne facture.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hayden McCullough",
        "i": "HM",
        "b": "Il est arrivé rapidement. Le livre est vraiment super, j'ai adoré ! C'est pour l'offrir à ma petite fille. 10/10 🥰",
        "r": 5,
        "p": []
      },
      {
        "n": "Yong Schulist",
        "i": "YS",
        "b": "Excellente qualité. J'apprécie particulièrement que les photos soient imprimées sur une seule face de la page.",
        "r": 5,
        "p": []
      },
      {
        "n": "Fatima Murphy",
        "i": "FM",
        "b": "Des dessins très mignons de chats domestiques dans différents contextes. Ce sera amusant à colorier.",
        "r": 5,
        "p": []
      },
      {
        "n": "Rozanne Mertz",
        "i": "RM",
        "b": "Le livre est agréable, plus grand que ce que j'imaginais, et les illustrations sont magnifiques.",
        "r": 5,
        "p": []
      },
      {
        "n": "Christopher O'Keefe",
        "i": "CO",
        "b": "Les draps sont de bonne qualité, ils ne sont pas transparents et les motifs sont très beaux.",
        "r": 5,
        "p": []
      },
      {
        "n": "Brock Larkin",
        "i": "BL",
        "b": "Très bon matériau, l'impression est excellente et il y a une grande variété de motifs :)",
        "r": 5,
        "p": []
      },
      {
        "n": "Jewell Weimann",
        "i": "JW",
        "b": "Superbe livre de coloriage ! Parfait pour le style tendance du dessin au marqueur.",
        "r": 5,
        "p": []
      },
      {
        "n": "Valorie Rohan",
        "i": "VR",
        "b": "Cela ressemble à la description. Très bon état et qualité. J'adore l'esthétique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hobert Effertz",
        "i": "HE",
        "b": "Cela ressemble à la description. Très bon état et qualité. J'adore l'esthétique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Dodie Hauck",
        "i": "DH",
        "b": "Cela ressemble à la description. Très bon état et qualité. J'adore l'esthétique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Trenton Stracke",
        "i": "TS",
        "b": "C'est exactement comme sur les images, très joli et de bonne qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Maranda Watsica",
        "i": "MW",
        "b": "comme le montrent les images, il suffit de tester avec les marqueurs",
        "r": 5,
        "p": []
      },
      {
        "n": "Edwardo Osinski",
        "i": "EO",
        "b": "Cadeau pour ma meilleure amie, il y a des chats elle va aimer.",
        "r": 5,
        "p": []
      },
      {
        "n": "Ronnie Mills",
        "i": "RM",
        "b": "Cadeau pour ma meilleure amie, il y a des chats elle va aimer",
        "r": 5,
        "p": []
      },
      {
        "n": "Zonia Cremin",
        "i": "ZC",
        "b": "Je les recommande, ils sont de bonne qualité et amusants",
        "r": 5,
        "p": []
      },
      {
        "n": "Darren Turcotte",
        "i": "DT",
        "b": "Très joli livre de coloriage, ma fille est ravie ;).",
        "r": 5,
        "p": []
      },
      {
        "n": "Rueben Durgan",
        "i": "RD",
        "b": "Très joli livre de coloriage, ma fille est ravie :)",
        "r": 5,
        "p": []
      },
      {
        "n": "Brittaney Kris",
        "i": "BK",
        "b": "Très bien, et l'emballage est également de qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Lucius Treutel",
        "i": "LT",
        "b": "C'est magnifique ! Il est arrivé très rapidement.",
        "r": 5,
        "p": []
      },
      {
        "n": "Larita Bahringer",
        "i": "LB",
        "b": "Très bien, bien qu'il soit arrivé plié et cassé.",
        "r": 5,
        "p": []
      },
      {
        "n": "Horace Kohler",
        "i": "HK",
        "b": "expédition super rapide et arrivée rapidement.",
        "r": 5,
        "p": []
      },
      {
        "n": "Berna O'Hara",
        "i": "BO",
        "b": "Je les adore !!!! J'ai hâte de les utiliser !!",
        "r": 5,
        "p": []
      }
    ]
  },
  "le-duo-marqueur-acrylique": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Lavern Bechtelar",
        "i": "LB",
        "b": "Les marqueurs sont vraiment sympas. Je les recommande vivement. Ils ne dégoulinent pas, sont super brillants et saturés. Une couleur couvre l'autre. Le blanc couvre le noir. Ils ne dégoulinent pas de l'autre côté de la feuille, même si l'enfant dessine sur du papier de bureau ordinaire. Livrés à temps, bien emballés.",
        "r": 5,
        "p": []
      },
      {
        "n": "Frances Schaden",
        "i": "FS",
        "b": "Les feutres sont de très bonnes qualités je suis ravis. Il n’en manque aucun et ils fonctionnent tous très bien. Il y a un large choix de couleurs. Ils ne traversent pas du tout la feuille. Il est même possible de faire plusieurs couches, ils ne laissent pas de traces.",
        "r": 5,
        "p": []
      },
      {
        "n": "Jan Murray",
        "i": "JM",
        "b": "Exactement ce qui a été proposé. Il semble être de bonne qualité et est arrivé rapidement. \n Les crayons ont un bon poids, ils fonctionnent tous bien, et la couleur offre une excellente couverture. Je les ai vraiment aimés et je les rachèterais sans hésiter.",
        "r": 5,
        "p": []
      },
      {
        "n": "Herschel Lakin",
        "i": "HL",
        "b": "Les couleurs sont belles et offrent une couverture décente. \n \n La pointe du pinceau a également la taille parfaite, ni trop grande ni \n \n trop petit. Je ne peux pas encore me prononcer sur la longévité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Arlie Kuvalis",
        "i": "AK",
        "b": "Pour l'instant, voici ce que nous avons commandé, exactement comme sur la photo, et ils ont l'air bien. \n Nous verrons quand nous l'utiliserons. Satisfait de l'achat jusqu'à présent. Nous recommandons",
        "r": 5,
        "p": []
      },
      {
        "n": "Sandee Lynch",
        "i": "SL",
        "b": "Excellente qualité, je recommande vivement. Conforme à la description. Sans hésitation, 5 étoiles maximales. Je l'utilise pour peindre des pièces imprimées en 3D.",
        "r": 5,
        "p": []
      },
      {
        "n": "Shirley Steuber",
        "i": "SS",
        "b": "Hourra ! Ils sont arrivés ! Tout est parfait, je recommande vivement et la livraison est rapide. C'est ma deuxième commande. Merci beaucoup au vendeur !",
        "r": 5,
        "p": []
      },
      {
        "n": "Stephen Cassin",
        "i": "SC",
        "b": "J'ai essayé quelques couleurs et il semble que ce soit un excellent produit, totalement recommandé. La livraison a pris plus de temps que prévu.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hector Cassin",
        "i": "HC",
        "b": "Ces marqueurs sont vraiment incroyables... Couverture à 100% avec toutes les couleurs et sur n'importe quel matériau... Fortement recommandés✌🏻",
        "r": 5,
        "p": []
      },
      {
        "n": "Armanda Hessel",
        "i": "AH",
        "b": "Ils arrivent en excellent état, scellés, impeccables. Ils sont exactement comme sur la photo et se ressemblent beaucoup aux marqueurs Posca.",
        "r": 5,
        "p": []
      },
      {
        "n": "Owen McKenzie",
        "i": "OM",
        "b": "Excellent, je ne suis pas doué pour la peinture 🖍️, c'est la première fois que je colore quelque chose et j'ai adoré le résultat !!!",
        "r": 5,
        "p": []
      },
      {
        "n": "Vernon Herman",
        "i": "VH",
        "b": "Ils offrent une très bonne couverture. Un petit test sur un matériau lisse et ils ont très bien fonctionné, très satisfait.",
        "r": 5,
        "p": []
      },
      {
        "n": "Timothy Parisian",
        "i": "TP",
        "b": "les meilleurs stylos de tous les temps. j'adore la pointe. couleur et opacité étonnantes. Ça vaut vraiment le coup ! !",
        "r": 5,
        "p": []
      },
      {
        "n": "Candida Bogan",
        "i": "CB",
        "b": "très bien emballé, excellente qualité, ma fille est très contente, je le recommande à tout le monde",
        "r": 5,
        "p": []
      },
      {
        "n": "Krishna Olson",
        "i": "KO",
        "b": "La livraison a été très rapide, tout est arrivé en parfait état, la boîte ne semble pas endommagée.",
        "r": 5,
        "p": []
      },
      {
        "n": "Weston King",
        "i": "WK",
        "b": "Couleurs parfaites et pinceau de très fine précision ! Je vais certainement en commander plus",
        "r": 5,
        "p": []
      },
      {
        "n": "Galen Dare",
        "i": "GD",
        "b": "Les stylos fonctionnent très bien, les couleurs sont des tons pastel et il y a peu d'encre.",
        "r": 5,
        "p": []
      },
      {
        "n": "Denis Steuber",
        "i": "DS",
        "b": "Les marqueurs sont arrivés bien emballés et je suis sûr qu’ils feront très bien l’affaire.",
        "r": 5,
        "p": []
      },
      {
        "n": "Max Feil",
        "i": "MF",
        "b": "Je suis très satisfait de l'achat, je le recommande. Ces marqueurs sont spectaculaires.",
        "r": 5,
        "p": []
      },
      {
        "n": "Liz Hansen",
        "i": "LH",
        "b": "je suis très satisfait, les feutres sont super et ma commande est arrivée rapidement",
        "r": 5,
        "p": []
      },
      {
        "n": "Berna D'Amore",
        "i": "BD",
        "b": "Excellents crayons, j'ai vraiment aimé les couleurs!!! L'expédition a été rapide !",
        "r": 5,
        "p": []
      },
      {
        "n": "Ione Fadel",
        "i": "IF",
        "b": "Très bien emballé, arrivé rapidement, produit original. Fortement recommandé !!!",
        "r": 5,
        "p": []
      },
      {
        "n": "Greta Hackett",
        "i": "GH",
        "b": "Excellent produit ! Arrivé rapidement, fortement recommandé ! Grande qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Claud Haag",
        "i": "CH",
        "b": "Arrivé rapidement, et la qualité est vraiment au rendez-vous !",
        "r": 5,
        "p": []
      },
      {
        "n": "Belkis Johnson",
        "i": "BJ",
        "b": "Les marqueurs sont étonnamment bons, la peinture a bien fini",
        "r": 5,
        "p": []
      }
    ]
  },
  "le-duo-marqueur-acrylique-double-pointe": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Lavern Bechtelar",
        "i": "LB",
        "b": "Les marqueurs sont vraiment sympas. Je les recommande vivement. Ils ne dégoulinent pas, sont super brillants et saturés. Une couleur couvre l'autre. Le blanc couvre le noir. Ils ne dégoulinent pas de l'autre côté de la feuille, même si l'enfant dessine sur du papier de bureau ordinaire. Livrés à temps, bien emballés.",
        "r": 5,
        "p": []
      },
      {
        "n": "Frances Schaden",
        "i": "FS",
        "b": "Les feutres sont de très bonnes qualités je suis ravis. Il n’en manque aucun et ils fonctionnent tous très bien. Il y a un large choix de couleurs. Ils ne traversent pas du tout la feuille. Il est même possible de faire plusieurs couches, ils ne laissent pas de traces.",
        "r": 5,
        "p": []
      },
      {
        "n": "Jan Murray",
        "i": "JM",
        "b": "Exactement ce qui a été proposé. Il semble être de bonne qualité et est arrivé rapidement. \n Les crayons ont un bon poids, ils fonctionnent tous bien, et la couleur offre une excellente couverture. Je les ai vraiment aimés et je les rachèterais sans hésiter.",
        "r": 5,
        "p": []
      },
      {
        "n": "Herschel Lakin",
        "i": "HL",
        "b": "Les couleurs sont belles et offrent une couverture décente. \n \n La pointe du pinceau a également la taille parfaite, ni trop grande ni \n \n trop petit. Je ne peux pas encore me prononcer sur la longévité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Arlie Kuvalis",
        "i": "AK",
        "b": "Pour l'instant, voici ce que nous avons commandé, exactement comme sur la photo, et ils ont l'air bien. \n Nous verrons quand nous l'utiliserons. Satisfait de l'achat jusqu'à présent. Nous recommandons",
        "r": 5,
        "p": []
      },
      {
        "n": "Sandee Lynch",
        "i": "SL",
        "b": "Excellente qualité, je recommande vivement. Conforme à la description. Sans hésitation, 5 étoiles maximales. Je l'utilise pour peindre des pièces imprimées en 3D.",
        "r": 5,
        "p": []
      },
      {
        "n": "Shirley Steuber",
        "i": "SS",
        "b": "Hourra ! Ils sont arrivés ! Tout est parfait, je recommande vivement et la livraison est rapide. C'est ma deuxième commande. Merci beaucoup au vendeur !",
        "r": 5,
        "p": []
      },
      {
        "n": "Stephen Cassin",
        "i": "SC",
        "b": "J'ai essayé quelques couleurs et il semble que ce soit un excellent produit, totalement recommandé. La livraison a pris plus de temps que prévu.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hector Cassin",
        "i": "HC",
        "b": "Ces marqueurs sont vraiment incroyables... Couverture à 100% avec toutes les couleurs et sur n'importe quel matériau... Fortement recommandés✌🏻",
        "r": 5,
        "p": []
      },
      {
        "n": "Armanda Hessel",
        "i": "AH",
        "b": "Ils arrivent en excellent état, scellés, impeccables. Ils sont exactement comme sur la photo et se ressemblent beaucoup aux marqueurs Posca.",
        "r": 5,
        "p": []
      },
      {
        "n": "Owen McKenzie",
        "i": "OM",
        "b": "Excellent, je ne suis pas doué pour la peinture 🖍️, c'est la première fois que je colore quelque chose et j'ai adoré le résultat !!!",
        "r": 5,
        "p": []
      },
      {
        "n": "Vernon Herman",
        "i": "VH",
        "b": "Ils offrent une très bonne couverture. Un petit test sur un matériau lisse et ils ont très bien fonctionné, très satisfait.",
        "r": 5,
        "p": []
      },
      {
        "n": "Timothy Parisian",
        "i": "TP",
        "b": "les meilleurs stylos de tous les temps. j'adore la pointe. couleur et opacité étonnantes. Ça vaut vraiment le coup ! !",
        "r": 5,
        "p": []
      },
      {
        "n": "Candida Bogan",
        "i": "CB",
        "b": "très bien emballé, excellente qualité, ma fille est très contente, je le recommande à tout le monde",
        "r": 5,
        "p": []
      },
      {
        "n": "Krishna Olson",
        "i": "KO",
        "b": "La livraison a été très rapide, tout est arrivé en parfait état, la boîte ne semble pas endommagée.",
        "r": 5,
        "p": []
      },
      {
        "n": "Weston King",
        "i": "WK",
        "b": "Couleurs parfaites et pinceau de très fine précision ! Je vais certainement en commander plus",
        "r": 5,
        "p": []
      },
      {
        "n": "Galen Dare",
        "i": "GD",
        "b": "Les stylos fonctionnent très bien, les couleurs sont des tons pastel et il y a peu d'encre.",
        "r": 5,
        "p": []
      },
      {
        "n": "Denis Steuber",
        "i": "DS",
        "b": "Les marqueurs sont arrivés bien emballés et je suis sûr qu’ils feront très bien l’affaire.",
        "r": 5,
        "p": []
      },
      {
        "n": "Max Feil",
        "i": "MF",
        "b": "Je suis très satisfait de l'achat, je le recommande. Ces marqueurs sont spectaculaires.",
        "r": 5,
        "p": []
      },
      {
        "n": "Liz Hansen",
        "i": "LH",
        "b": "je suis très satisfait, les feutres sont super et ma commande est arrivée rapidement",
        "r": 5,
        "p": []
      },
      {
        "n": "Berna D'Amore",
        "i": "BD",
        "b": "Excellents crayons, j'ai vraiment aimé les couleurs!!! L'expédition a été rapide !",
        "r": 5,
        "p": []
      },
      {
        "n": "Ione Fadel",
        "i": "IF",
        "b": "Très bien emballé, arrivé rapidement, produit original. Fortement recommandé !!!",
        "r": 5,
        "p": []
      },
      {
        "n": "Greta Hackett",
        "i": "GH",
        "b": "Excellent produit ! Arrivé rapidement, fortement recommandé ! Grande qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Claud Haag",
        "i": "CH",
        "b": "Arrivé rapidement, et la qualité est vraiment au rendez-vous !",
        "r": 5,
        "p": []
      },
      {
        "n": "Belkis Johnson",
        "i": "BJ",
        "b": "Les marqueurs sont étonnamment bons, la peinture a bien fini",
        "r": 5,
        "p": []
      }
    ]
  },
  "le-pastel-marqueurs-acryliques": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Darius Pacocha",
        "i": "DP",
        "b": "Les couleurs sont magnifiques, vous pouvez faire des dégradés, bien sûr, si vous savez comment procéder. \n Vous pouvez dessiner dessus, ça sèche rapidement et vous pouvez passer le stylo dessus une fois sec, très bien.",
        "r": 5,
        "p": []
      },
      {
        "n": "Serina Brekke",
        "i": "SB",
        "b": "J'ai aimé. 👏🏽   J'espère que le magasin choisira une autre entreprise de livraison à l'avenir, le service postal ici au Brésil est la pire entreprise qui existe !",
        "r": 5,
        "p": []
      },
      {
        "n": "Lewis Schroeder",
        "i": "LS",
        "b": "Produit de qualité \n   Il est arrivé bien emballé, tout comme dans la publicité. Les stylos sont très bien pigmentés, avec un excellent rapport qualité-prix.",
        "r": 5,
        "p": []
      },
      {
        "n": "Kerstin Jenkins",
        "i": "KJ",
        "b": "Produit de qualité avec des couleurs éclatantes, même pendant la période des fêtes la livraison a été rapide via le service postal.",
        "r": 5,
        "p": []
      },
      {
        "n": "Bert Crona",
        "i": "BC",
        "b": "J'ai différentes marques en plus de celles-ci (molotow, pilot pintor, obertone, liquitex) \n Et pour le prix, ils sont parfaits",
        "r": 5,
        "p": []
      },
      {
        "n": "Claude Hermiston",
        "i": "CH",
        "b": "Test de couleur sur carton : 24 marqueurs acryliques (communs), 12 couleurs de teint \"jaune\" et 12 couleurs de teint \"rouge\"",
        "r": 5,
        "p": []
      },
      {
        "n": "Maragaret Runolfsdottir",
        "i": "MR",
        "b": "Test de couleur sur carton : 24 marqueurs acryliques (communs), 12 couleurs de teint \"jaune\" et 12 couleurs de teint \"rouge\"",
        "r": 5,
        "p": []
      },
      {
        "n": "Neville Kuphal",
        "i": "NK",
        "b": "Si vous avez déjà le pack 168 Guangna, ne prenez pas ce set. sur les 72 couleurs il n'y en a que 24 de nouvelles.",
        "r": 5,
        "p": []
      },
      {
        "n": "Rob Buckridge",
        "i": "RB",
        "b": "si gentil. Ce set et le set de 24 macarons sont mes premiers marqueurs Guangna. je les aime jusqu'à présent.",
        "r": 5,
        "p": []
      },
      {
        "n": "Agustin Willms",
        "i": "AW",
        "b": "Les marqueurs sont incroyables ! Ils ont une très bonne couverture, une pointe fine et précise. Parfait",
        "r": 5,
        "p": []
      },
      {
        "n": "Myra Gleason",
        "i": "MG",
        "b": "Très bien, aucun n'est arrivé sec ou endommagé, les couleurs sont très similaires à l'image.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hoyt Dicki",
        "i": "HD",
        "b": "J'ai été extrêmement satisfait de ces marqueurs acryliques. La qualité est exceptionnelle.",
        "r": 5,
        "p": []
      },
      {
        "n": "Moshe Spinka",
        "i": "MS",
        "b": "Parfait ! Cela m'a beaucoup aidé à restaurer les couleurs de mes mains Cloth Myths.",
        "r": 5,
        "p": []
      },
      {
        "n": "Tammara Muller",
        "i": "TM",
        "b": "Ils peignent très bien, l'un des meilleurs acryliques que j'aie eu, à part Languo.",
        "r": 5,
        "p": []
      },
      {
        "n": "Murray Lakin",
        "i": "ML",
        "b": "Tout comme sur la photo, j'ai déjà essayé cette marque, c'est de bonne qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Donnetta Wiza",
        "i": "DW",
        "b": "Les couleurs sont de très haute qualité, de belles couleurs",
        "r": 5,
        "p": []
      },
      {
        "n": "Marcel Gorczany",
        "i": "MG",
        "b": "Je les ai testés et ils sont géniaux. 10/10 pour le prix",
        "r": 5,
        "p": []
      },
      {
        "n": "Cristopher Gerlach",
        "i": "CG",
        "b": "génial, reçu le produit en bon état. reste à l'essayer.",
        "r": 5,
        "p": []
      },
      {
        "n": "Reynaldo Fisher",
        "i": "RF",
        "b": "génial, reçu le produit en bon état. reste à l'essayer.",
        "r": 5,
        "p": []
      },
      {
        "n": "Sam Connelly",
        "i": "SC",
        "b": "marqueurs merveilleux... on peut acheter sans crainte.",
        "r": 5,
        "p": []
      },
      {
        "n": "Maryann Bernier",
        "i": "MB",
        "b": "C'est arrivé rapidement, j'adore les couleurs !",
        "r": 5,
        "p": []
      },
      {
        "n": "Rosalinda Effertz",
        "i": "RE",
        "b": "J'achèterai à nouveau expédition super rapide",
        "r": 5,
        "p": []
      },
      {
        "n": "Faustino Lehner",
        "i": "FL",
        "b": "J'adore la variété et la qualité des stylos.",
        "r": 5,
        "p": []
      },
      {
        "n": "Taunya Jast",
        "i": "TJ",
        "b": "Très bien emballé et protégé. Couleurs unies",
        "r": 5,
        "p": []
      },
      {
        "n": "Everette Hermann",
        "i": "EH",
        "b": "Stylos parfaits et livraison ultra-rapide.",
        "r": 5,
        "p": []
      }
    ]
  },
  "le-pastel-marqueurs-acryliques-tons-chair-macaron": {
    "count": 150,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Darius Pacocha",
        "i": "DP",
        "b": "Les couleurs sont magnifiques, vous pouvez faire des dégradés, bien sûr, si vous savez comment procéder. \n Vous pouvez dessiner dessus, ça sèche rapidement et vous pouvez passer le stylo dessus une fois sec, très bien.",
        "r": 5,
        "p": []
      },
      {
        "n": "Serina Brekke",
        "i": "SB",
        "b": "J'ai aimé. 👏🏽   J'espère que le magasin choisira une autre entreprise de livraison à l'avenir, le service postal ici au Brésil est la pire entreprise qui existe !",
        "r": 5,
        "p": []
      },
      {
        "n": "Lewis Schroeder",
        "i": "LS",
        "b": "Produit de qualité \n   Il est arrivé bien emballé, tout comme dans la publicité. Les stylos sont très bien pigmentés, avec un excellent rapport qualité-prix.",
        "r": 5,
        "p": []
      },
      {
        "n": "Kerstin Jenkins",
        "i": "KJ",
        "b": "Produit de qualité avec des couleurs éclatantes, même pendant la période des fêtes la livraison a été rapide via le service postal.",
        "r": 5,
        "p": []
      },
      {
        "n": "Bert Crona",
        "i": "BC",
        "b": "J'ai différentes marques en plus de celles-ci (molotow, pilot pintor, obertone, liquitex) \n Et pour le prix, ils sont parfaits",
        "r": 5,
        "p": []
      },
      {
        "n": "Claude Hermiston",
        "i": "CH",
        "b": "Test de couleur sur carton : 24 marqueurs acryliques (communs), 12 couleurs de teint \"jaune\" et 12 couleurs de teint \"rouge\"",
        "r": 5,
        "p": []
      },
      {
        "n": "Maragaret Runolfsdottir",
        "i": "MR",
        "b": "Test de couleur sur carton : 24 marqueurs acryliques (communs), 12 couleurs de teint \"jaune\" et 12 couleurs de teint \"rouge\"",
        "r": 5,
        "p": []
      },
      {
        "n": "Neville Kuphal",
        "i": "NK",
        "b": "Si vous avez déjà le pack 168 Guangna, ne prenez pas ce set. sur les 72 couleurs il n'y en a que 24 de nouvelles.",
        "r": 5,
        "p": []
      },
      {
        "n": "Rob Buckridge",
        "i": "RB",
        "b": "si gentil. Ce set et le set de 24 macarons sont mes premiers marqueurs Guangna. je les aime jusqu'à présent.",
        "r": 5,
        "p": []
      },
      {
        "n": "Agustin Willms",
        "i": "AW",
        "b": "Les marqueurs sont incroyables ! Ils ont une très bonne couverture, une pointe fine et précise. Parfait",
        "r": 5,
        "p": []
      },
      {
        "n": "Myra Gleason",
        "i": "MG",
        "b": "Très bien, aucun n'est arrivé sec ou endommagé, les couleurs sont très similaires à l'image.",
        "r": 5,
        "p": []
      },
      {
        "n": "Hoyt Dicki",
        "i": "HD",
        "b": "J'ai été extrêmement satisfait de ces marqueurs acryliques. La qualité est exceptionnelle.",
        "r": 5,
        "p": []
      },
      {
        "n": "Moshe Spinka",
        "i": "MS",
        "b": "Parfait ! Cela m'a beaucoup aidé à restaurer les couleurs de mes mains Cloth Myths.",
        "r": 5,
        "p": []
      },
      {
        "n": "Tammara Muller",
        "i": "TM",
        "b": "Ils peignent très bien, l'un des meilleurs acryliques que j'aie eu, à part Languo.",
        "r": 5,
        "p": []
      },
      {
        "n": "Murray Lakin",
        "i": "ML",
        "b": "Tout comme sur la photo, j'ai déjà essayé cette marque, c'est de bonne qualité.",
        "r": 5,
        "p": []
      },
      {
        "n": "Donnetta Wiza",
        "i": "DW",
        "b": "Les couleurs sont de très haute qualité, de belles couleurs",
        "r": 5,
        "p": []
      },
      {
        "n": "Marcel Gorczany",
        "i": "MG",
        "b": "Je les ai testés et ils sont géniaux. 10/10 pour le prix",
        "r": 5,
        "p": []
      },
      {
        "n": "Cristopher Gerlach",
        "i": "CG",
        "b": "génial, reçu le produit en bon état. reste à l'essayer.",
        "r": 5,
        "p": []
      },
      {
        "n": "Reynaldo Fisher",
        "i": "RF",
        "b": "génial, reçu le produit en bon état. reste à l'essayer.",
        "r": 5,
        "p": []
      },
      {
        "n": "Sam Connelly",
        "i": "SC",
        "b": "marqueurs merveilleux... on peut acheter sans crainte.",
        "r": 5,
        "p": []
      },
      {
        "n": "Maryann Bernier",
        "i": "MB",
        "b": "C'est arrivé rapidement, j'adore les couleurs !",
        "r": 5,
        "p": []
      },
      {
        "n": "Rosalinda Effertz",
        "i": "RE",
        "b": "J'achèterai à nouveau expédition super rapide",
        "r": 5,
        "p": []
      },
      {
        "n": "Faustino Lehner",
        "i": "FL",
        "b": "J'adore la variété et la qualité des stylos.",
        "r": 5,
        "p": []
      },
      {
        "n": "Taunya Jast",
        "i": "TJ",
        "b": "Très bien emballé et protégé. Couleurs unies",
        "r": 5,
        "p": []
      },
      {
        "n": "Everette Hermann",
        "i": "EH",
        "b": "Stylos parfaits et livraison ultra-rapide.",
        "r": 5,
        "p": []
      }
    ]
  },
  "marqueur-acrylique-serie": {
    "count": 90,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Amandine Caron",
        "i": "AC",
        "b": "J'adore le concept des sets thématiques. Pris la version paysage et c'est top pour les compositions nature, on a tous les verts et bleus nécessaires sans avoir à investir dans un grand set. Pratique et économique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Bertrand Fournier",
        "i": "BF",
        "b": "Acheté la palette portrait, parfaite pour compléter ma collection. 12 couleurs ciblées et harmonieuses, pas besoin d'en faire plus pour ce thème spécifique. Encre identique aux autres sets, qualité constante.",
        "r": 5,
        "p": []
      },
      {
        "n": "Marc Lefebvre",
        "i": "ML",
        "b": "Set portrait reçu, exactement ce qu'il me fallait pour mes illustrations de personnages. Les tons chair et terre se complètent parfaitement, gain de temps énorme par rapport à composer ma palette à la main.",
        "r": 5,
        "p": []
      },
      {
        "n": "Pierre Mercier",
        "i": "PM",
        "b": "Idée brillante de proposer des palettes thématiques. J'ai pris la version aquatique et c'est parfait pour mes illustrations marines. Les bleus sont magnifiques, vraiment fidèles à l'océan.",
        "r": 5,
        "p": []
      },
      {
        "n": "Florence Joly",
        "i": "FJ",
        "b": "Pris pour offrir à ma fille passionnée par les fleurs. La palette est juste sublime, tous les roses, mauves et verts qu'il faut. Elle a fait un mandala fleuri magnifique le soir même.",
        "r": 5,
        "p": []
      },
      {
        "n": "Lucie Bernard",
        "i": "LB",
        "b": "Reçue rapidement, palette aquatique vraiment réussie. Les nuances de bleu et turquoise sont précises, parfaites pour le coloriage de paysages côtiers et la peinture de poissons.",
        "r": 5,
        "p": []
      },
      {
        "n": "Sarah Klein",
        "i": "SK",
        "b": "Très bonne entrée de gamme pour découvrir la marque. La palette ciblée évite l'effet où l'on a trop de couleurs et on ne sait pas laquelle prendre. Idéal pour offrir aussi.",
        "r": 5,
        "p": []
      },
      {
        "n": "Clémence Dubois",
        "i": "CD",
        "b": "Bon produit pour qui débute ou veut une thématique précise. Les 12 couleurs suffisent largement quand on travaille sur un sujet ciblé. Encre fluide, pointe pinceau souple.",
        "r": 5,
        "p": []
      },
      {
        "n": "Thomas Garnier",
        "i": "TG",
        "b": "J'aime beaucoup ce concept de série spéciale, ça permet d'avoir une palette ciblée sans investir dans 100 couleurs. Le rendu est aussi qualitatif que les sets plus chers.",
        "r": 5,
        "p": []
      },
      {
        "n": "Élise Martin",
        "i": "EM",
        "b": "Acheté pour compléter mon set principal, très contente. Les couleurs de cette palette sont introuvables ailleurs, ça m'a permis de varier mes créations.",
        "r": 5,
        "p": []
      }
    ]
  },
  "serie-speciale-12-marqueurs-acryliques-thematiques": {
    "count": 90,
    "avg": "4.9",
    "reviews": [
      {
        "n": "Amandine Caron",
        "i": "AC",
        "b": "J'adore le concept des sets thématiques. Pris la version paysage et c'est top pour les compositions nature, on a tous les verts et bleus nécessaires sans avoir à investir dans un grand set. Pratique et économique.",
        "r": 5,
        "p": []
      },
      {
        "n": "Bertrand Fournier",
        "i": "BF",
        "b": "Acheté la palette portrait, parfaite pour compléter ma collection. 12 couleurs ciblées et harmonieuses, pas besoin d'en faire plus pour ce thème spécifique. Encre identique aux autres sets, qualité constante.",
        "r": 5,
        "p": []
      },
      {
        "n": "Marc Lefebvre",
        "i": "ML",
        "b": "Set portrait reçu, exactement ce qu'il me fallait pour mes illustrations de personnages. Les tons chair et terre se complètent parfaitement, gain de temps énorme par rapport à composer ma palette à la main.",
        "r": 5,
        "p": []
      },
      {
        "n": "Pierre Mercier",
        "i": "PM",
        "b": "Idée brillante de proposer des palettes thématiques. J'ai pris la version aquatique et c'est parfait pour mes illustrations marines. Les bleus sont magnifiques, vraiment fidèles à l'océan.",
        "r": 5,
        "p": []
      },
      {
        "n": "Florence Joly",
        "i": "FJ",
        "b": "Pris pour offrir à ma fille passionnée par les fleurs. La palette est juste sublime, tous les roses, mauves et verts qu'il faut. Elle a fait un mandala fleuri magnifique le soir même.",
        "r": 5,
        "p": []
      },
      {
        "n": "Lucie Bernard",
        "i": "LB",
        "b": "Reçue rapidement, palette aquatique vraiment réussie. Les nuances de bleu et turquoise sont précises, parfaites pour le coloriage de paysages côtiers et la peinture de poissons.",
        "r": 5,
        "p": []
      },
      {
        "n": "Sarah Klein",
        "i": "SK",
        "b": "Très bonne entrée de gamme pour découvrir la marque. La palette ciblée évite l'effet où l'on a trop de couleurs et on ne sait pas laquelle prendre. Idéal pour offrir aussi.",
        "r": 5,
        "p": []
      },
      {
        "n": "Clémence Dubois",
        "i": "CD",
        "b": "Bon produit pour qui débute ou veut une thématique précise. Les 12 couleurs suffisent largement quand on travaille sur un sujet ciblé. Encre fluide, pointe pinceau souple.",
        "r": 5,
        "p": []
      },
      {
        "n": "Thomas Garnier",
        "i": "TG",
        "b": "J'aime beaucoup ce concept de série spéciale, ça permet d'avoir une palette ciblée sans investir dans 100 couleurs. Le rendu est aussi qualitatif que les sets plus chers.",
        "r": 5,
        "p": []
      },
      {
        "n": "Élise Martin",
        "i": "EM",
        "b": "Acheté pour compléter mon set principal, très contente. Les couleurs de cette palette sont introuvables ailleurs, ça m'a permis de varier mes créations.",
        "r": 5,
        "p": []
      }
    ]
  }
};